import { createApiClient } from './ApiClientFactory'

const BASE_URL = import.meta.env.VITE_BASE_URL || 'http://localhost:5000'
const apiClient = createApiClient(BASE_URL)

/**
 * AgentEventService — calls /agent-events endpoints (Narrative Feed).
 *
 * These are AI-agent-generated events (detections, actions, status changes),
 * NOT raw device telemetry or security camera events.
 */
export default {
  /**
   * List agent events — paginated Narrative Feed.
   * @param {Object} params Query params (page, limit, agent_type, severity, category, status, from, to, keyword)
   */
  async getEvents(params = {}) {
    const { data } = await apiClient.get('/agent-events', { params })
    return data
  },

  /**
   * Get event statistics aggregated by agent type, severity, and status.
   * @param {Object} params Query params (agent_type, from, to)
   */
  async getEventStats(params = {}) {
    const { data } = await apiClient.get('/agent-events/stats', { params })
    return data
  },

  /**
   * Get a specific agent event by ID.
   * @param {String} eventId
   */
  async getEvent(eventId) {
    const { data } = await apiClient.get(`/agent-events/${eventId}`)
    return data
  },

  /**
   * Submit feedback on an event (e.g. mark as false positive).
   * @param {String} eventId
   * @param {Object} payload { is_false_positive: Boolean, comment: String }
   */
  async submitFeedback(eventId, payload) {
    const { data } = await apiClient.patch(`/agent-events/${eventId}/feedback`, payload)
    return data
  },

  /**
   * Resolve an open or in-progress event.
   * @param {String} eventId
   */
  async resolveEvent(eventId) {
    const { data } = await apiClient.patch(`/agent-events/${eventId}/resolve`)
    return data
  },
}
